<div class="form-container">
  <form [formGroup]='setPasswordForm'>

    <div>
      <div class="form-field col-12 md:col-12 lg:col-12">
        <div class="form-errors alert alert-danger" [hidden]='!changePasswordErrors[0]["general"]'>
          <div *ngFor="let ErrorMessage of changePasswordErrors['general']">
            {{ErrorMessage.message}}
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="form-field col-12">
        <div class="form-label">
          <label for="newPassword" translate>label_new_password</label>
          <label class="asterisk">*</label>
        </div>
        <div class="form-control password-field">
          <input pPassword [type]="inputType" class="password-field" formControlName="newPassword" [feedback]="false" />
          <span class="eye-icon sign-in-eye" (click)="tooglePasswordType()">
            <i *ngIf="inputType === 'password'" class="fa fa-fw fa-eye-slash" aria-hidden="true"></i>
            <i *ngIf="inputType !== 'password'" class="fa fa-fw fa-eye" aria-hidden="true"></i>
          </span>
        </div>
        <div class="form-errors"
          *ngIf="setPasswordForm.controls.newPassword.errors  && (setPasswordForm.controls.newPassword.dirty || setPasswordForm.controls.newPassword.touched)">
          <div [hidden]="!setPasswordForm.controls.newPassword.errors.required" translate>
            error_new_password_required
          </div>
          <div [hidden]="!setPasswordForm.controls.newPassword.errors.minlength && !setPasswordForm.controls.newPassword.errors.pattern" translate>
            error_password_validation
          </div>
          <!-- <div [hidden]="!setPasswordForm.controls.newPassword.errors.maxlength" translate>
            exceed_max_length
          </div> -->
        </div>
      </div>

      <div class="form-field col-12">
        <div class="form-label">
          <label for="newConfirmPassword" translate>label_new_confirm_password</label>
          <label class="asterisk">*</label>
        </div>
        <div class="form-control password-field ">
          <input [type]="cnfInputType" class="password-field" pPassword formControlName="newConfirmPassword" [feedback]="false"/>
          <span class="eye-icon sign-in-eye" (click)="toogleCnfPasswordType()">
            <i *ngIf="cnfInputType === 'password'" class="fa fa-fw fa-eye-slash" aria-hidden="true"></i>
            <i *ngIf="cnfInputType !== 'password'" class="fa fa-fw fa-eye" aria-hidden="true"></i>
          </span>
        </div>
        <div class="form-errors"
          *ngIf="setPasswordForm.controls.newConfirmPassword.errors  && (setPasswordForm.controls.newConfirmPassword.dirty || setPasswordForm.controls.newConfirmPassword.touched)">
          <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.required" translate>
            error_new_confirm_password_required
          </div>
          <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.minlength && !setPasswordForm.controls.newConfirmPassword.errors.pattern" translate>
            error_password_validation
          </div>
          <!-- <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.maxlength" translate>
            exceed_max_length
          </div> -->
        </div>
      </div>


      <div class="col-12">
        <div class="form-buttons">
          <button pButton appRipple type="button" style="width:100%" [label]="'label_done' | translate"
            [disabled]="!setPasswordForm.valid" (click)="doChangePassword()"></button>
        </div>
      </div>
    </div>
  </form>
</div>